import { Typography } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import isToday from 'date-fns/is_today';
import Icons from '../Icons/Icons.component';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PeopleIcon from '@material-ui/icons/People';
import PhoneIcon from '@material-ui/icons/Phone';
import cn from 'classnames';
import moment from 'moment';
import React, { useState, useEffect, useContext } from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_NEW,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
  ORDER_STATUS_CANCELLED,
} from '../../Constants/Order/Order.constants';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import { createOrderPageLink } from '../../Pages/Order/Order.page.route';
import { createOrdersPageLink } from '../../Pages/Orders/Orders.page.route';
import orderConfirmationDoneSelector from '../../State/Store/Orders/Selectors/OrderConfirmationDone.selector';
import orderConfirmationErrorSelector from '../../State/Store/Orders/Selectors/OrderConfirmationError.selector';
import orderConfirmedSelector from '../../State/Store/Orders/Selectors/OrderConfirmed.selector';
import orderItemSelector from '../../State/Store/Orders/Selectors/OrderItem.selector';
import ordersSelectedLoadingSelector from '../../State/Store/Orders/Selectors/OrderSelectedLoading.selector';
import {
  UI_EDIT_ORDER_CLOSE,
  UI_MODIFY_ORDER_OPEN_CLICK,
  UI_ORDER_DETAILS_ICON_CANCEL_CLICK,
  UI_ORDER_DETAILS_ICON_CONFIRM_CLICK,
  UI_ORDER_DETAILS_MENU_CALL_CLICK,
  UI_ORDER_DETAILS_MENU_CANCEL_CLICK,
  UI_ORDER_DETAILS_MENU_CONFIRM_CLICK,
  UI_SHOW_ACTIVITY_LOG,
  UI_PLUS_LOAD_ACTION_MENU_GET_BTN,
  UI_VIEW_TRUCKS_CLICK,
} from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import ActivityLogModal from '../ActivityLog/ActivityLogModalComp';
import OrderConfirmationDialog from '../OrderConfirmationDialog/OrderConfirmationDialog.component';
import OrderConfirmationMessage from '../OrderConfirmationMessage/OrderConfirmationMessage.component';
import OrderStatus from '../OrderStatus/OrderStatus.component';
import orderDetailsHeaderStyles from './OrderDetailsHeader.component.styles';
import PendingChip from './PendingChip.component';
import PlusLoadModal from './parts/PlusLoadModal';
import { compose } from 'recompose';
import hitGTM from 'State/Store/UI/Actions/GTM.action';
import uiTriggered from 'State/Store/UI/Actions/UI.Triggered.action';
import ServicesContext from 'Contexts/Services/Services.context';
import EditOrderModal from './edit/EditOrderModal';
import ControlPointDuplicateIcon from '@material-ui/icons/ControlPointDuplicate';
import { Order } from 'types/Order';
import { callBoralTel } from 'utils/call-boral-tel';
import { shouldShowPlusLoad } from './parts/utils/should-show-plus-load';
import { UI_TEXT_GET_A_PLUS_LOAD } from 'ui-format-utils.ts/ui-text/get-a-plus-load';
import ordersFindById from 'State/Store/Orders/Actions/OrdersFindById.action';
import PlusLoadExceptionModal from './parts/PlusLoadExceptionModal';
import { checkThenOpenPlusLoadModal } from './utils/check-then-open-plus-load-modal';
import sidebarActionCreators from '../../State/Store/Sidebar/Sidebar.actions';
import TrucksMapDialog from '../TrucksMapDialog/TrucksMapDialog.component';

interface Props {
  backLink: any;
  history: any;
  actions: any;
  currentOrder: Order;
  classes: any;
  orderId: any;
  orderConfirmed: any;
  orderConfirmationDone: any;
  orderConfirmationError: any;
  selectedOrderLoading: any;
  entry: any;
  width: any;
  onRefresh: any;
}

const OrderDetailsHeaderComponent = (props: Props) => {
  const {
    backLink,
    history,
    actions,
    currentOrder,
    classes,
    orderId,
    orderConfirmed,
    orderConfirmationDone,
    orderConfirmationError,
    selectedOrderLoading,
    entry,
    width,
    onRefresh,
  } = props;
  const dispatch = useDispatch();
  const services = useContext(ServicesContext);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [tradingRegionSet, setTradingRegionSet] = useState(false);
  const [showEditOrderOption, setShowEditOrderOption] = useState(false);
  const [showActivity, setShowActivity] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [plusLoadModalRerenderKey, setPlusLoadModalRerenderKey] = useState<number>(0);
  const [showOptions, setShowOptions] = useState<any>(null);
  const [isOpenEditOrderModal, setIsOpenEditOrderModal] = useState(false);
  const [editOrderModalRefreshingKey, setEditOrderModalRefreshingKey] = useState(1);

  useEffect(() => {
    const doOnce = async () => {
      try {
        setTradingRegionSet(true);
        const loadedDates = await services.orderService.getDatesDetails(currentOrder.details!.tradingRegion);

        /**
         * Gets next day moment
         * @param {moment} today moment to get day for
         * @returns {moment} moment next day
         */
        const getNextDay = (today: any) => {
          return today.clone().add(1, `days`);
        };

        /**
         * Gets number of non working days after specific day
         * @param {moment} from moment to get working days after
         * @param {number} total initial total to starts with
         * @returns {number} total of non working days after
         */
        const getNonWorkingDaysAfter = (from: any, total: any): any => {
          if (
            getNextDay(from).weekday() === 0 ||
            // or check if next day is holiday
            !!loadedDates.find((el: any) => moment(el).isSame(getNextDay(from), `day`))
          ) {
            return getNonWorkingDaysAfter(getNextDay(from), total + 1);
          }
          return total;
        };
        nonWorkingDays = getNonWorkingDaysAfter(moment(), 0);
      } catch (ex) {
        // if anything goes wrong just check if next day is sunday and ignore all holidays logic, thats all
        nonWorkingDays =
          moment()
            .add(1, `days`)
            .weekday() === 0
            ? 1
            : 0;
      }
    };

    // check if order is ready at all
    if (!currentOrder || !currentOrder.summary || !currentOrder.details) {
      return;
    }
    // before anythinbg else check if tomorrow is sunday and if so we need toadd 1 day
    let nonWorkingDays = 0;

    // the we check if trading region is provided, if it is then check if tomorrow (and if so, followinf days) is holiday, or sunday. Do it only once, if trading region exists and if its also not same as in prevProps
    if (!tradingRegionSet) {
      doOnce();
    } else {
      // tradingRegion is not provided and we cannot get list of holidays and calculate non working days so only just check if its sunday tomorrow, if so add a day
      nonWorkingDays =
        moment()
          .add(1, `days`)
          .weekday() === 0
          ? 1
          : 0;
    }

    const startTime = currentOrder.summary.startTime.replace(`.`, `:`);
    if (
      currentOrder.details.isModificationRestricted ||
      currentOrder.details.isPendingModification ||
      (currentOrder.summary.status !== ORDER_STATUS_TO_BE_CONFIRMED &&
        currentOrder.summary.status !== ORDER_STATUS_CONFIRMED &&
        currentOrder.summary.status !== ORDER_STATUS_ON_HOLD) ||
      // is Today
      moment()
        .startOf(`day`)
        .isSame(moment(startTime).startOf(`day`)) ||
      // if its tomorrow order and currently its after 3pm
      (moment()
        .add(nonWorkingDays + 1, `day`)
        .startOf(`day`)
        .isSame(moment(startTime).startOf(`day`)) &&
        new Date().getHours() >= 15) ||
      // or after 4 weeks from now
      moment(startTime).isAfter(moment().add(4, `weeks`))
    ) {
      if (showEditOrderOption) {
        setShowEditOrderOption(false);
      }
    } else if (!showEditOrderOption) {
      setShowEditOrderOption(true);
    }
  }, [currentOrder]);

  const onClose = () => {
    if (backLink) {
      history.replace(backLink);
      return;
    }
    history.push(createOrdersPageLink());
  };

  const onClickHandler = (target: any) => {
    setShowOptions(target);
  };

  const handleOptionsClose = () => {
    setShowOptions(null);
  };

  const onCloseConfirmDialog = () => {
    setIsOrderModalOpen(false);
  };

  const onActivityLogOpen = () => {
    setShowActivity(true);
    setShowOptions(null);
    dispatch(uiTriggered({ onlyOnce: true, type: UI_SHOW_ACTIVITY_LOG }));
  };

  const orderMenuClick = (isConfirmModal: any) => {
    if (isConfirmModal) {
      dispatch(hitGTM(UI_ORDER_DETAILS_MENU_CONFIRM_CLICK));
    } else {
      dispatch(hitGTM(UI_ORDER_DETAILS_MENU_CANCEL_CLICK));
    }
    setIsOrderModalOpen(true);
    setIsConfirmModal(isConfirmModal);
    setShowOptions(null);
  };

  const orderIconClick = (isConfirmModal: any) => {
    if (isConfirmModal) {
      dispatch(hitGTM(UI_ORDER_DETAILS_ICON_CONFIRM_CLICK));
    } else {
      dispatch(hitGTM(UI_ORDER_DETAILS_ICON_CANCEL_CLICK));
    }
    setIsOrderModalOpen(true);
    setIsConfirmModal(isConfirmModal);
  };

  const orderMenuCallBoralClick = () => {
    dispatch(hitGTM(UI_ORDER_DETAILS_MENU_CALL_CLICK));
    handleOptionsClose();
    callBoralTel(currentOrder.details.boralTel);
  };
  const viewTrucksClick = () => {
    dispatch(uiTriggered({ type: UI_VIEW_TRUCKS_CLICK }));
    handleOptionsClose();
    handleRefineToggle();
  };

  const onEditOrderOpen = async () => {
    dispatch(uiTriggered({ type: UI_MODIFY_ORDER_OPEN_CLICK }));
    setEditOrderModalRefreshingKey(editOrderModalRefreshingKey + 1);
    setIsOpenEditOrderModal(true);
  };

  const onPlusLoadModalCloseWhenDone = () => {
    const date = currentOrder.orderKey.slice(0, currentOrder.orderKey.indexOf('-'));
    const orderCode = currentOrder.orderKey.slice(currentOrder.orderKey.indexOf('-') + 1, currentOrder.orderKey.lastIndexOf('-'));
    const orderLine = currentOrder.orderKey.slice(currentOrder.orderKey.lastIndexOf('-') + 1);
    dispatch(
      ordersFindById({
        date,
        orderCode,
        orderLine,
      }),
    );
  };

  const onGoToThisOrder = () => {
    setIsOpenEditOrderModal(false);
    history.push(createOrderPageLink({ orderId }));
    onRefresh();
  };

  const onGoToOrders = () => {
    setIsOpenEditOrderModal(false);
    history.push(createOrdersPageLink());
  };

  const handlePlusLoadClick = () => {
    dispatch(hitGTM(UI_PLUS_LOAD_ACTION_MENU_GET_BTN));
    checkThenOpenPlusLoadModal({
      services,
      dispatch,
      order: currentOrder,
    });
    setPlusLoadModalRerenderKey(plusLoadModalRerenderKey + 1);
  };

  /**
   * Open the refine menu
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof OrderDetailsHeaderComponent
   */
  const handleRefineToggle = () => {
    actions.sidebarRightToggle();
  };

  const renderHeader = (currentOrder: Order) => {
    const { summary, details } = currentOrder;
    if (!summary || !details) {
      return null;
    }
    const { orderCode, status, startTime } = summary;

    const isInitial = orderConfirmed === null && orderConfirmationDone === null;
    const showStatus = !selectedOrderLoading || isInitial || (orderConfirmationDone === true && orderConfirmationError);
    const isSmall = isWidthDown(`sm`, width);

    const canCancelOrder = details && services.orderService.canCancelOrder(entry, summary, details);
    const canConfirmOrder = !orderConfirmed && services.orderService.canConfirmOrder(entry, summary);

    const shouldDisplayDelete = canCancelOrder && status !== ORDER_STATUS_NEW;
    const shouldDisplayCallBoral = status !== ORDER_STATUS_NEW;
    const shouldShowPendingChip = currentOrder.details && currentOrder.details.isPendingModification;
    const showPlusLoad = shouldShowPlusLoad(currentOrder);

    let truckSpacing = details ? details.qty.ordered : 0;
    if (details && details.spacing && typeof details.spacing === `string` && details.spacing.endsWith(` min`)) {
      truckSpacing = Number(details.spacing.replace(` min`, ``));
    }

    const hasViewLoad =
      isToday(summary.startTime.replace(`.`, `:`)) &&
      summary.status !== ORDER_STATUS_TO_BE_CONFIRMED &&
      summary.status !== ORDER_STATUS_NEW &&
      summary.status !== ORDER_STATUS_CANCELLED;

    return (
      <React.Fragment>
        {/* the part on the left */}
        <Grid alignItems="center" classes={{ container: classes.toolbar }} container item wrap="nowrap">
          <Grid alignItems="center" container item wrap="nowrap">
            <Grid item>
              <IconButton onClick={onClose}>
                <ChevronLeftIcon />
              </IconButton>
            </Grid>

            <Grid item>
              <Typography variant={isSmall ? 'h6' : 'h4'} className={classes.title}>
                {`Order ${orderCode}`}
              </Typography>
            </Grid>

            {showStatus && (
              <Grid item className={cn(classes.statusContainer)}>
                <div className={cn(classes.displayFlex)}>
                  <OrderStatus status={status} />
                  {shouldShowPendingChip && (
                    <div className={classes.marginLeft1unit}>
                      <PendingChip />
                    </div>
                  )}
                </div>
              </Grid>
            )}

            <Grid className={cn(classes.flexGrow1, classes.textAlignRight)} item>
              <Grid container justify="flex-end" alignItems="center">
                {showEditOrderOption && (
                  <Grid item className={cn(classes.smUp, classes.marginRight1unit)}>
                    <Button variant="outlined" color="primary" onClick={onEditOrderOpen}>
                      <EditIcon className={classes.iconLeft} />
                      Modify Order
                    </Button>
                  </Grid>
                )}
                {canConfirmOrder && (
                  <Grid item className={classes.smUp}>
                    <Tooltip title="Confirm Order">
                      <IconButton color="inherit" onClick={() => orderIconClick(true)}>
                        <AssignmentTurnedInIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                {showPlusLoad && (
                  <Grid item className={classes.smUp}>
                    <Tooltip title={UI_TEXT_GET_A_PLUS_LOAD}>
                      <IconButton color="inherit" onClick={handlePlusLoadClick}>
                        <ControlPointDuplicateIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                {shouldDisplayDelete && (
                  <Grid item className={classes.smUp}>
                    <Tooltip title="Cancel Order">
                      <IconButton color="inherit" onClick={() => orderIconClick(false)}>
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                <Grid item>
                  <IconButton className={classes.optionsButton} aria-haspopup="true" color="inherit" onClick={(event) => onClickHandler(event.currentTarget)}>
                    <MoreVertIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            {showActivity && (
              <ActivityLogModal
                isOpen={showActivity}
                onClose={() => {
                  setShowActivity(false);
                }}
                order={currentOrder}
              />
            )}
          </Grid>
        </Grid>

        {/* the part on the right */}
        <Menu anchorEl={showOptions || null} id="simple-menu" onClose={handleOptionsClose} open={Boolean(showOptions)}>
          {showEditOrderOption && (
            <MenuItem onClick={onEditOrderOpen} className={classes.smDown}>
              <EditIcon className={classes.iconLeft} />
              Modify Order
            </MenuItem>
          )}
          {canConfirmOrder && (
            <MenuItem onClick={() => orderMenuClick(true)} className={classes.smDown}>
              <AssignmentTurnedInIcon className={classes.iconLeft} />
              Confirm order
            </MenuItem>
          )}
          {showPlusLoad && (
            <MenuItem onClick={handlePlusLoadClick} className={classes.smDown}>
              <ControlPointDuplicateIcon className={classes.iconLeft} />
              {UI_TEXT_GET_A_PLUS_LOAD}
            </MenuItem>
          )}
          {shouldDisplayDelete && (
            <MenuItem onClick={() => orderMenuClick(false)} className={classes.smDown}>
              <DeleteIcon className={classes.iconLeft} />
              Cancel order
            </MenuItem>
          )}
          {hasViewLoad && (
            <MenuItem onClick={viewTrucksClick} className={classes.mdDown}>
              <Icons type="TRUCK" className={cn(classes.iconLeft, classes.customIcon)} />
              View Trucks
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              handleOptionsClose();
              onActivityLogOpen();
            }}
          >
            <PeopleIcon className={classes.iconLeft} />
            View Activity
          </MenuItem>
          {shouldDisplayCallBoral && (
            <MenuItem className={classes.smUp} onClick={orderMenuCallBoralClick}>
              <PhoneIcon className={classes.iconLeft} />
              {`Call Boral ${details && details.boralTel ? `(${details.boralTel})` : ``}`}
            </MenuItem>
          )}
        </Menu>

        {details && (
          <EditOrderModal
            key={editOrderModalRefreshingKey}
            open={isOpenEditOrderModal}
            order={currentOrder}
            onClose={() => {
              setIsOpenEditOrderModal(false);
              dispatch(uiTriggered({ type: UI_EDIT_ORDER_CLOSE }));
            }}
            onGoToThisOrder={onGoToThisOrder}
            onGoToOrders={onGoToOrders}
          />
        )}
        <OrderConfirmationDialog
          details={details}
          i18nSection={isConfirmModal ? `OrderConfirmation` : `OrderCancellation`}
          onNoClick={onCloseConfirmDialog}
          onYesClick={onCloseConfirmDialog}
          open={!!isOrderModalOpen}
          orderKey={currentOrder.orderKey}
          summary={summary}
        />

        <OrderConfirmationMessage currentOrder={currentOrder} i18nSection={isConfirmModal ? `OrderConfirmation` : `OrderCancellation`} />

        <PlusLoadModal
          key={`PlusLoadModal#${plusLoadModalRerenderKey}`}
          order={currentOrder}
          onGoToThisOrder={onGoToThisOrder}
          onGoToOrders={onGoToOrders}
          onCloseWhenDone={onPlusLoadModalCloseWhenDone}
        />

        <PlusLoadExceptionModal order={currentOrder} />
      </React.Fragment>
    );
  };

  return currentOrder && renderHeader(currentOrder);
};

const OrderDetailsHeader = compose<any, any>(
  withWidth(),
  withRouter,
  withEntries,
  withStyles(themeCreateInjectableStyles(orderDetailsHeaderStyles) as any, { withTheme: true }),
  connect(
    () => (state, ownProps) => {
      const { orderId } = ownProps as any;
      const orderEntitySelector = orderItemSelector(orderId);
      return {
        currentOrder: orderEntitySelector(state),
        orderConfirmationDone: orderConfirmationDoneSelector(state),
        orderConfirmationError: orderConfirmationErrorSelector(state),
        orderConfirmed: orderConfirmedSelector(state),
        selectedOrderLoading: ordersSelectedLoadingSelector(state),
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...sidebarActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderDetailsHeaderComponent);

export default OrderDetailsHeader;
